import React from 'react';
import { Form } from 'react-bootstrap';
import ClientInfo from '../../atoms/ClientInfo/view';
import './style.css';

const ThirdPartySearch = ({ selectedThird, onSelect }) => {
  return (
    <div className="third-party-search-standard">
      <Form.Label className="text-secondary small fw-bold text-uppercase mb-2">Tercero / Cliente (Auditoría)</Form.Label>
      <ClientInfo 
        tercero={selectedThird} 
        onSelected={onSelect} // Note: ClientInfo primarily uses events but let's see if we can pass it
      />
    </div>
  );
};

export default ThirdPartySearch;
